module.exports = __webpack_public_path__ + "assets/img/2019_7.d668bd74.png";